import { useMocks } from '../../../shared/env';
import { HttpCompanyPartnersGateway, HttpPartnerGateway } from './HttpPartnerGateway';
import { MockCompanyPartnersGateway, MockPartnerGateway } from './MockPartnerGateway';
import type { CompanyPartnersGateway, PartnerGateway } from './PartnerGateway';

export const partnerGateway: PartnerGateway = useMocks ? new MockPartnerGateway() : new HttpPartnerGateway();
export const companyPartnersGateway: CompanyPartnersGateway = useMocks ? new MockCompanyPartnersGateway() : new HttpCompanyPartnersGateway();

/** True when the portal is showing the in-memory demo firm. The shell then labels everything "Synthetic Demo Data". */
export const isSyntheticPartnerData = useMocks;
